import { getKeycloakRedirectUri, getKeycloakRegistrationUrl } from '../../environments';

export const QUICK_LINKS_FIRST_TOUCH_KEY = 'qc_ql_first_touch';

export function rememberQuickLinksOwner(ownerId: string): void {
  const id = String(ownerId || '').trim();
  if (!id) return;
  try {
    if (localStorage.getItem(QUICK_LINKS_FIRST_TOUCH_KEY)) return;
    localStorage.setItem(QUICK_LINKS_FIRST_TOUCH_KEY, id);
  } catch {
    /* storage can be blocked */
  }
}

export function readQuickLinksOwner(): string {
  try {
    return (localStorage.getItem(QUICK_LINKS_FIRST_TOUCH_KEY) || '').trim();
  } catch {
    return '';
  }
}

export function attributeRedirect(redirectUri: string): string {
  const ownerId = readQuickLinksOwner();
  if (!ownerId) return redirectUri;
  const url = new URL(redirectUri);
  url.searchParams.set('signUpSource', 'quicklinks');
  url.searchParams.set('quickLinksOwnerId', ownerId);
  return url.toString();
}

export function registrationUrl(redirectUri: string): string {
  const attributed = attributeRedirect(redirectUri);
  try {
    localStorage.setItem('redirect_uri', attributed);
  } catch {
    /* storage can be blocked */
  }
  return getKeycloakRegistrationUrl(attributed);
}

export function profileRegistrationUrl(): string {
  return registrationUrl(getKeycloakRedirectUri());
}
